export default "__VITE_ASSET__CfgCVeYL__"